import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useInView } from 'react-intersection-observer';
import { API_BASE_URL } from '../../config/constants';
import axios from 'axios';
import "../../css/Gastronomia.css"

const Gastronomia = ({ theme = 'ltm' }) => {
    const [productosDestacados, setProductosDestacados] = useState([]);
    const [textoGastronomia, setTextoGastronomia] = useState("");
    const navigate = useNavigate();

    const [loaded, setLoaded] = useState({
        img1: false,
        img2: false,
        img3: false,
    });

    const handleImageLoad = (imgKey) => {
        setLoaded((prev) => ({ ...prev, [imgKey]: true }));
    };

    const { ref: textRef, inView: textInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: imagesRef, inView: imagesInView } = useInView({ threshold: 0.1, triggerOnce: true });

    useEffect(() => {
        const fetchDestacados = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/getProductosDestacados`);
                setProductosDestacados(response.data.productosDestacados);
            } catch (err) {
                console.error(err);
            }
        };

        fetchDestacados();
    }, []);

    useEffect(() => {
        const fetchTextoGastronomia = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/getTextoGastronomia`);
                if (response.data && response.data.texto) {
                    setTextoGastronomia(response.data.texto);
                }
            } catch (err) {
                console.error("Error obteniendo el texto de gastronomia:", err);
            }
        };

        fetchTextoGastronomia();
    }, []);

    return (
        <div id="gastronomia" className={`${theme}-fondo-rojo py-5`}>
            <div className={`${theme}-gastronomia-main-div pt-md-3`}>
                <Row>
                    <Col ref={imagesRef} className={`px-5 pb-4 pb-md-5 gastronomia-transition-element ${imagesInView ? 'gastronomia-animate-in-left' : ''}`} md={6}>
                        <Row className="mb-2 g-2 g-md-3">
                            <Col xs={6}>
                                {!loaded.img1 && <Skeleton height="clamp(20vh, 40vh, 40vh)" width="100%" />}
                                <img
                                    src="/imagenes/Fotos/trago 1000x1000.jpeg"
                                    alt="Image 1"
                                    className="img-fluid"
                                    style={{
                                        objectFit: "cover",
                                        height: "100%",
                                        display: loaded.img1 ? "block" : "none",
                                    }}
                                    onLoad={() => handleImageLoad("img1")}
                                />
                            </Col>
                            <Col xs={6}>
                                {!loaded.img2 && <Skeleton height="clamp(20vh, 40vh, 40vh)" width="100%" />}
                                <img
                                    src="/imagenes/Fotos/CAFETERIA 1000X1000.png"
                                    alt="Image 2"
                                    className="img-fluid"
                                    style={{
                                        objectFit: "cover",
                                        height: "100%",
                                        display: loaded.img2 ? "block" : "none",
                                    }}
                                    onLoad={() => handleImageLoad("img2")}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}>
                                {!loaded.img3 && <Skeleton height="clamp(20vh, 40vh, 40vh)" width="100%" />}
                                <img
                                    src="/imagenes/Fotos/foto 7 web - comida - hamburguesa.jpg"
                                    alt="Comida"
                                    className="img-fluid"
                                    style={{
                                        objectFit: "cover",
                                        width: "100%",
                                        display: loaded.img3 ? "block" : "none",
                                    }}
                                    onLoad={() => handleImageLoad("img3")}
                                />
                            </Col>
                        </Row>
                    </Col>

                    <Col ref={textRef} className={`text-end gastronomia-transition-element ${textInView ? 'gastronomia-animate-in-right' : ''}`} md={6}>
                        <h1 className={`${theme}-titulo-gastronomia pt-4 mx-5`}>COMÉ RICO,</h1>
                        <h1 className={`${theme}-titulo-gastronomia mx-5`}>DISFRUTÁ TU TRAGO,</h1>
                        <h1 className={`${theme}-titulo-gastronomia pb-5 mx-5`}>DELEITATE CON UN CAFÉ.</h1>

                        <h4 className={`${theme}-subtitulo-gastronomia mx-5 mb-4 `}><strong>ABIERTO HASTA LA MADRUGADA</strong></h4>
                        <h4 className={`${theme}-subtitulo-2-gastronomia mx-5 mb-4 mb-lg-5`}>
                            Una carta pensada para compartir, <br /> brindar y volver a Bingo Bahía.
                        </h4>

                        <div className={`${theme}-gastronomia-container d-none d-md-block`}>
                            <h3 className={`${theme}-gastronomia-container-titulo mt-3 mx-2 mb-4`}>DESTACADOS DEL MES</h3>
                            <h3 className={`${theme}-gastronomia-container-subtitulo mx-2 mb-4`}>{textoGastronomia}</h3>

                            {productosDestacados.map((producto, index) => (
                                <Row key={producto.id || index} className={`${theme}-gastronomia-item-row mb-2`}>
                                    <Col className={`${theme}-gastronomia-container-item`}>
                                        {"- " + producto.nombre || `Item nº${index + 1}`}
                                    </Col>
                                </Row>
                            ))}

                        </div>
                    </Col>
                </Row>

                <div className={`${theme}-gastronomia-container-mobile d-md-none`}>
                    <h3 className={`${theme}-gastronomia-container-titulo-mobile mt-3 mx-2 mb-4`}>DESTACADOS DEL MES</h3>
                    <h3 className={`${theme}-gastronomia-container-subtitulo mx-2 mb-4`}>{textoGastronomia}</h3>

                    {productosDestacados.map((producto, index) => (
                        <Row key={producto.id || index} className={`${theme}-gastronomia-item-row mb-2`}>
                            <Col className={`${theme}-gastronomia-container-item-mobile`}>
                                {"- " + producto.nombre || `Item nº${index + 1}`}
                            </Col>
                        </Row>
                    ))}

                </div>
            </div>
        </div>
    );
};

export default Gastronomia;
